var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-cy":"evaluationDetailPageContainer"}},[_c('Breadcrumb',{attrs:{"crumbs":_vm.breadcrumbItems}}),_c('EvaluationDetail',{attrs:{"evaluation-id":_vm.evaluationId,"user-id":_vm.userId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }